// Site firewall endpoints, keyed by bare site_slug:
//   GET|PUT        /api/v1/sites/{site_slug}/firewall-policy
//   GET|POST       /api/v1/sites/{site_slug}/firewall-rules
//   PUT|DELETE     /api/v1/sites/{site_slug}/firewall-rules/{rule_id}
// Mirrors backend/src/orixen_hub/api/v1/site_firewall.py.

import { request, type ApiResponse } from "../client";
import type {
  FirewallPolicy,
  FirewallPolicyIn,
  FirewallRule,
  RuleCreateIn,
  RuleUpdateIn,
} from "../types/siteFirewall";

const base = (s: string) => `/api/v1/sites/${encodeURIComponent(s)}`;

export const siteFirewall = {
  getPolicy: (siteSlug: string): Promise<ApiResponse<FirewallPolicy>> =>
    request<FirewallPolicy>("GET", `${base(siteSlug)}/firewall-policy`),

  putPolicy: (
    siteSlug: string,
    body: FirewallPolicyIn,
  ): Promise<ApiResponse<FirewallPolicy>> =>
    request<FirewallPolicy>("PUT", `${base(siteSlug)}/firewall-policy`, body),

  listRules: (siteSlug: string): Promise<ApiResponse<FirewallRule[]>> =>
    request<FirewallRule[]>("GET", `${base(siteSlug)}/firewall-rules`),

  createRule: (
    siteSlug: string,
    body: RuleCreateIn,
  ): Promise<ApiResponse<FirewallRule>> =>
    request<FirewallRule>("POST", `${base(siteSlug)}/firewall-rules`, body),

  updateRule: (
    siteSlug: string,
    ruleId: string,
    body: RuleUpdateIn,
  ): Promise<ApiResponse<FirewallRule>> =>
    request<FirewallRule>(
      "PUT",
      `${base(siteSlug)}/firewall-rules/${encodeURIComponent(ruleId)}`,
      body,
    ),

  deleteRule: (siteSlug: string, ruleId: string): Promise<ApiResponse<void>> =>
    request<void>(
      "DELETE",
      `${base(siteSlug)}/firewall-rules/${encodeURIComponent(ruleId)}`,
    ),
};
